import axios from 'axios';
import { getUrl } from '@/config/api.routes';
const basePath = 'management.smart_control';
import { buildEncodedUrl } from '@/libs/urlencoding';


export default {
  namespaced: true,
  state: {
    smartControlList: [],
    smartContol: {},
    rules: [],
    rule: {},
  },
  mutations: {
    SET_SMART_CONTROL_LIST(state, list) {
      state.smartControlList = list;
    },
    SET_SMART_CONTROL(state, item) {
      state.smartContol = item;
    },
    SET_RULES(state, list) {
      state.rules = list;
    },
    SET_RULE(state, item) {
      state.rule = item;
    },
  },
  actions: {
    async getSmartControlList({ commit }, payload) {
      const [params, searchOffset] = payload;

      const url = buildEncodedUrl(
        getUrl(`${basePath}.control`),
        params,
      );

      const response = await axios.get(url);
      if (!searchOffset) {
        //append to previous list
        commit('SET_SMART_CONTROL_LIST', [...this.state.smartControl.smartControlList, ...response.data.models]);
      } else {
        commit('SET_SMART_CONTROL_LIST', response.data.models);
      }
      return response;
    },
    async getSmartControl({ commit }, id) {
      const response = await axios.get(getUrl(`${basePath}.control`, id));
      commit('SET_SMART_CONTROL', response.data);
      return response;
    },

    async getRuleList({ commit }, payload) {
      const [params, searchOffset] = payload;

      const url = buildEncodedUrl(
        getUrl(`${basePath}.rule`),
        params,
      );

      const response = await axios.get(url);

      if (!searchOffset) {
        //append to previous list
        commit('SET_RULES', [...this.state.smartControl.rules, ...response.data.models]);
      } else {
        commit('SET_RULES', response.data.models);
      }
      return response;
    },
    async getRule({ commit }, id) {
      const response = await axios.get(getUrl(`${basePath}.rule`, id));
      commit('SET_RULE', response.data);
      return response;
    },
    async createRule(_, payload) {
      const response = await axios.post(getUrl(`${basePath}.rule`), payload);
      return response;
    },

    async updateRule(_, payload) {
      const { id, data } = payload;
      const response = await axios.put(getUrl(`${basePath}.rule`, id), data);
      return response;
    },

    deleteRule(_, id) {
      return axios.delete(getUrl(`${basePath}.rule`, id));
    },
    fetchStages() {
      return axios.get(getUrl(`${basePath}.stages`));
    },
  },
};
